import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ScrollToTop.jsx
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const el = document.getElementById("main-scroll");
    if (el) {
      el.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname]);

  return null;
}
